import { Box, Stack, styled, Typography } from '@mui/material';

export const LocationAddress = styled(Typography)(({ theme }) => ({
	display: 'inline-block',
	maxWidth: '100%',
	color: theme.palette.primary.main,
	textDecoration: 'underline',
	cursor: 'pointer',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
}));

export const TransportCard = styled(Box)(({ theme }) => ({
	borderRadius: theme.spacing(1),
	padding: '8px 8px 8px 12px',
	backgroundColor: theme.palette.common.white,
	boxShadow: '0 6px 4px -2px rgba(24, 39, 75, 0.12)',
	border: `0.25px solid ${theme.palette.primary[200]}`,
}));

export const TransportCardInfoContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: theme.spacing(1, 0),
	gap: theme.spacing(1),
}));

export const TransportCardInfo = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1),
}));

export const TransportCardInfoSubtitle = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	color: theme.palette.solutions?.[600],
	gap: theme.spacing(1),
}));

export const DetailTextStyled = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(0.5),
}));

export const LegCardsColumn = styled(Box)(({ theme }) => ({
	flex: 1,
	padding: theme.spacing(0.5, 0),
}));

export const WalkIndicatorContainer = styled(Stack)(({ theme }) => ({
	flexDirection: 'row',
	alignItems: 'center',
	gap: theme.spacing(0.5),
	color: theme.palette.solutions?.[600],
}));

export const RouteStopContent = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'isLast',
})<{ isLast?: boolean }>(({ theme, isLast }) => ({
	gap: theme.spacing(3),
	marginBottom: isLast ? 0 : theme.spacing(3),
	marginTop: '-1px',
	flex: 1,
	minWidth: 0,
}));

export const TimelineConnector = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'dashed',
})<{ dashed?: boolean }>(({ theme, dashed }) => ({
	width: dashed ? 0 : 1,
	minHeight: 20,
	backgroundColor: dashed ? 'transparent' : theme.palette.primary.main,
	flex: 1,
	...(dashed && {
		borderLeft: `1px dashed ${theme.palette.solutions?.[600]}`,
	}),
}));

export const TimelineIconContainer = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'isStart',
})<{ isStart?: boolean }>(({ isStart }) => ({
	alignItems: 'center',
	paddingTop: '2px',
	gap: isStart ? 0 : '2px',
}));
